import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
`;

export const Image = styled.img`
  display: block;
  margin: 0 auto 32px auto;

  @media (max-width: 768px) {
    width: 78px;
    margin-bottom: 24px;
  }
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: 2.4rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver100};
    text-align: center;
    line-height: 28px;
    margin: 0;

    @media (max-width: 768px) {
      margin-bottom: 10px;
    }
  `}
`;

export const Text = styled.p`
  ${({ theme }) => css`
    font-size: 1.6rem;
    line-height: 2.6rem;
    font-weight: 400;
    color: ${theme.colors.neutralSilver70};

    @media (max-width: 768px) {
      max-width: 176px;
      margin: 0 auto;
    }
  `}
`;
